export const FETCH_REPORT_PAGE_REQUEST = 'REPORT_PAGE/FETCH_REPORT_PAGE_REQUEST';
export const FETCH_REPORT_PAGE_FAILURE = 'REPORT_PAGE/FETCH_REPORT_PAGE_FAILURE';
export const FETCH_REPORT_PAGE_SUCCESS = 'REPORT_PAGE/FETCH_REPORT_PAGE_SUCCESS';
